import { render, staticRenderFns } from "./ContentArea.vue?vue&type=template&id=86d6beb8&"
import script from "./ContentArea.vue?vue&type=script&lang=js&"
export * from "./ContentArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports